// @flow
type Group = string;
export type ExperimentGroups = { [expName: string]: Group };
/**
 * Abstract class for the Experiments Client
 */
export default class AExperimentsClient {
  // Experiments that have no group do not have an entry.
  active: ExperimentGroups;
  triggerable: ExperimentGroups;
  useBatching: boolean = false;

  constructor(
    active: ExperimentGroups,
    triggerable: ExperimentGroups,
    useBatching: boolean = false,
  ) {
    this.active = active;
    this.triggerable = triggerable;
    this.useBatching = useBatching;
  }

  flush() {
    // no-op. Provided so client implementations can batch calls
  }

  /**
   * Returns the group of the current user
   */
  v2GetGroup(name: string): ?string {
    let group = this.active[name];
    if (group === undefined) {
      group = this.triggerable[name];
    }
    return group || null;
  }

  /**
   * Returns the group of the SEO experiment session. SEO experiments
   * can only be in active list.
   */
  v2GetSEOGroup(name: string): ?string {
    return this.active[name];
  }

  /**
   * Returns a boolean if the user is in the specified group(s)
   */
  v2InGroup(name: string, groups: Group | Array<Group>): boolean {
    const group = this.v2GetGroup(name);
    if (typeof groups === 'string') {
      groups = [groups];
    }
    return group ? groups.indexOf(group) !== -1 : false;
  }

  /**
   * Activates the experiment
   * @abstract
   */
  v2ActivateExperiment(name: string): ?string {
    throw new Error('Method must be implemented by subclass.');
  }

  /**
   * Triggers experiment activation for an override group
   */
  v2LogExperimentGroupOverride(name: string, overrideGroup: string, isSeoExp: ?boolean): void {
    throw new Error('Method must be implemented by subclass.');
  }
}
